import { BreadCrumbs, HomeIcon, TextBody, TextHeading } from '@isdd/idsk-ui-kit/index'
import { CenterWrapper } from '@isdd/metais-common/components/center-wrapper/CenterWrapper'
import { PORTAL_URL, metaisEmail } from '@isdd/metais-common/constants'
import { LoginRouteNames } from '@isdd/metais-common/navigation/routeNames'
import { useTranslation } from 'react-i18next'

export const LoginProblemsPage = () => {
    const { t } = useTranslation()

    return (
        <>
            <BreadCrumbs
                withWidthContainer
                links={[
                    { label: t('breadcrumbs.home'), href: PORTAL_URL, icon: HomeIcon },
                    { label: t('breadcrumbs.prelogin'), href: '#', toLogin: true },
                    { label: t('breadcrumbs.loginProblems'), href: LoginRouteNames.LOGIN_PROBLEMS },
                ]}
            />
            <CenterWrapper>
                <TextHeading size="XL">{t('loginProblems.heading')}</TextHeading>
                <TextBody>
                    {t('loginProblems.description')} <a href={`mailto:${metaisEmail}`}>{metaisEmail}</a>.
                </TextBody>
            </CenterWrapper>
        </>
    )
}
